import React, { useContext } from "react";
import AuthContext from "../../context/auth/authContext";
import { AiFillStar } from "react-icons/ai";
const VtradingScreen4 = () => {
  const { userData } = useContext(AuthContext);
  const { profile_data } = userData;
  return (
    <div className="VtradingScreen3">
      <div className="VtradingScreen3__container">
        <header>
          <h2>Portfolio Tour</h2>
          <div className="VtradingScreen3__header__details">
            <h2>My Connections (10)</h2>
            <h2>My Portfolios (4) </h2>
          </div>
        </header>
        <section>
          <main>
            <ul>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, index) => (
                <li key={index}>
                  <div className="item1">
                    <figure>
                      <img src={profile_data.avatar} alt="avatar" />
                    </figure>
                    <div>
                      <p>{profile_data.name}</p>
                      <p>@dhanush</p>
                    </div>
                  </div>

                  <div className="item2">
                    <div>
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                    </div>
                    <p>75% Response</p>
                  </div>

                  <div>
                    <p>
                      Total % P : <span>100%</span>
                    </p>
                  </div>
                  <div>
                    <p>
                      Total Part : <span>5</span>
                    </p>
                  </div>

                  <div className="item4">
                    <button
                      className="TradathonRoom__join__button"
                      style={{
                        background: "rgba(232, 189, 110, 1)",
                        borderRadius: "5px",
                      }}
                    >
                      &nbsp;view&nbsp;
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </main>
        </section>

        <center>
          <div className="SingleCrypto__buttons__group">
            <button className="SingleCrypto__grid__compare__button">
              Expert’s Portfolios
            </button>

            <button className="SingleCrypto__grid__moreinfo__button">
              Take Portfolio Tour
            </button>
          </div>
        </center>
      </div>
    </div>
  );
};

export default VtradingScreen4;
